import React, { FC, ReactElement } from 'react'
import BitconIcon from '@/icons/bitcoin-filled'
import Wallet from '@/utils/wallet'
import useSatoshiPriceUSD from '@/utils/hooks/useSatoshiPriceUSD'

const InscriptionActionCancel: FC<{
	price?: number
	rune?: boolean
	id: string
	onComplete: () => void
	onlyShowPrice?: boolean
}> = (props): ReactElement => {
	const loadingRef = React.useRef(false)
	const [balanceUSD, _isLoadingBalanceUSD] = useSatoshiPriceUSD((props as any).price * 1e8)

	const handleCancel = React.useCallback(async () => {
		loadingRef.current = true

		if (props.rune) {
			await Wallet.cancelRuneEscrow(props.id)
		} else {
			await Wallet.cancelEscrow(props.id)
		}

		loadingRef.current = false
		props.onComplete && props.onComplete()
	}, [props])
	const handleCancelKeyDown = React.useCallback(
		(event: React.KeyboardEvent<HTMLDivElement>) => {
			if (event.key === 'Enter' || event.key === ' ') {
				event.preventDefault()
				void handleCancel()
			}
		},
		[handleCancel]
	)

	const displayPrice = React.useMemo(
		() => Math.floor((props.price ?? 0) * 1e5) / 1e5,
		[props.price]
	)

	return (
		<div className="flex items-center justify-between">
			{props.price && (
				<div className="flex flex-col gap-0.5">
					<div className="flex gap-1 items-center">
						<BitconIcon className="size-4" />
						<p className="text-xs font-semibold">{displayPrice}</p>
					</div>
					{balanceUSD && <p className="text-[10px] text-muted-foreground">${balanceUSD}</p>}
				</div>
			)}
			{!props.onlyShowPrice && (
				<div
					onClick={handleCancel}
					className="h-7 bg-[#F04438] cursor-pointer text-foreground text-sm font-semibold flex items-center justify-center px-4 rounded-full"
					role="button"
					tabIndex={0}
					onKeyDown={handleCancelKeyDown}
				>
					Delist
				</div>
			)}
		</div>
	)
}

export default InscriptionActionCancel
